import AnalyticsService, { BillingEventNameAMP, EventNameAMP } from 'application/services/AnalyticsService';

export const sendEvent = (unpaidLicensesOnly: boolean, isNeedPayment: boolean) => {
  if (unpaidLicensesOnly) {
    AnalyticsService.event(EventNameAMP.BILLING_UNPAID_LICENSES_PAY_CLICKED);
  } else {
    const submitEventName = isNeedPayment
      ? BillingEventNameAMP.PAYMENT_MODAL_SUBMIT_PAYMENT
      : BillingEventNameAMP.PAYMENT_MODAL_SUBMIT_CONFIRM;

    AnalyticsService.event(submitEventName);
  }
};
